var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SettingsTitle',{attrs:{"title":"Scrolling behavior "}}),_c('SettingsLines',{attrs:{"items":_vm.items},on:{"changeState":_vm.changeState}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }